import { render, staticRenderFns } from "./create-promocode.vue?vue&type=template&id=1d49e5b1&"
import script from "./create-promocode.vue?vue&type=script&lang=js&"
export * from "./create-promocode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports